<div class="flex flex-col items-end text-[15px] leading-[20px]">
    <div class="capitalize">{{username}}</div>
    <div>{{role}}</div>
    @if (user?.Impersonation === true) {
    @if (user?.Training === true) {
    <div class="text-right text-[13px]">Training</div>
    }
    @else {
    <div class="text-right text-[13px]">Impersonated</div>
    }
    }
</div>